/*
 *
 * AbsenceDetail actions
 *
 */

import {
  // load
  LOAD_ABSENCE,
  LOAD_ABSENCE_SUCCESS,
  LOAD_ABSENCE_ERROR,
  // single
  CHANGE_ABSENCE,
  CHANGE_ABSENCE_SUCCESS,
  CHANGE_ABSENCE_ERROR,
  DELETE_ABSENCE,
  DELETE_ABSENCE_SUCCESS,
  DELETE_ABSENCE_ERROR,
  FLUSH_STATE_ABSENCEDETAIL,
} from './constants';

// Clearing the state
export function flushStateAbsenceDetail() {
  return {
    type: FLUSH_STATE_ABSENCEDETAIL,
  };
}

// Load All
export function loadAbsence(id) {
  return {
    type: LOAD_ABSENCE,
    id
  };
}
export function loadAbsenceSuccess(absenceData) {
  return {
    type: LOAD_ABSENCE_SUCCESS,
    absenceData
  };
}
export function loadAbsenceError(error) {
  return {
    type: LOAD_ABSENCE_ERROR,
    error,
  };
}

// Change One
export function changeAbsence(absenceData) {
  return {
    type: CHANGE_ABSENCE,
    absenceData,
  };
}
export function changeAbsenceSuccess(absenceData) {
  return {
    type: CHANGE_ABSENCE_SUCCESS,
    absenceData,
  };
}
export function changeAbsenceError(error) {
  return {
    type: CHANGE_ABSENCE_ERROR,
    error,
  };
}

// Delete
export function deleteAbsence(id) {
  return {
    type: DELETE_ABSENCE,
    id,
  };
}
export function deleteAbsenceSuccess() {
  return {
    type: DELETE_ABSENCE_SUCCESS,
  };
}
export function deleteAbsenceError(deleteError) {
  return {
    type: DELETE_ABSENCE_ERROR,
    deleteError,
  };
}


